/**
 * 颜色工具 - 统一的颜色方案
 */

import pc from 'picocolors';

export const colors = {
  // 基础颜色
  red: pc.red,
  green: pc.green,
  yellow: pc.yellow,
  blue: pc.blue,
  magenta: pc.magenta,
  cyan: pc.cyan,
  white: pc.white,
  gray: pc.gray,
  
  // 样式
  bold: pc.bold,
  dim: pc.dim,
  italic: pc.italic,
  underline: pc.underline,
  
  // 语义化颜色
  success: (text: string) => pc.green(text),
  error: (text: string) => pc.red(text),
  warning: (text: string) => pc.yellow(text),
  info: (text: string) => pc.blue(text),
  
  // 特定用途
  header: (text: string) => pc.bold(pc.cyan(text)),
  command: (text: string) => pc.cyan(text),
  path: (text: string) => pc.dim(pc.underline(text)),
  highlight: (text: string) => pc.bold(pc.yellow(text)),
  
  // 优先级颜色
  priority: {
    high: (text: string) => pc.red(text),
    medium: (text: string) => pc.yellow(text),
    low: (text: string) => pc.green(text),
  },
  
  // 状态颜色
  status: {
    pending: (text: string) => pc.gray(text),
    in_progress: (text: string) => pc.blue(text),
    completed: (text: string) => pc.green(text),
    failed: (text: string) => pc.red(text),
  },
  
  // 十六进制颜色支持（简化实现）
  hex: (color: string) => {
    // picocolors 不支持 hex，所以我们使用预定义映射
    const hexMap: Record<string, (text: string) => string> = {
      '#ff4444': pc.red,
      '#ff8800': pc.yellow,
      '#d73a49': pc.red,
      '#0366d6': pc.blue,
      '#28a745': pc.green,
      '#6f42c1': pc.magenta,
      '#e36209': pc.yellow,
      '#ffd33d': pc.yellow,
      '#61dafb': pc.cyan,
      '#339933': pc.green,
      '#b60205': pc.red,
      '#22863a': pc.green
    };
    return hexMap[color] || pc.white;
  }
};